export default [
  {
    name: 'defaultMessage',
    path: 'message',
    component: () => import(/* webpackChunkName: 'defaultMessage' */ '../views/patient/list/message.vue'),
  },
  {
    name: 'autoReplyList',
    path: 'autoReply',
    component: () => import(/* webpackChunkName: 'defaultMessage' */ '../views/patient/list/autoReply.vue'),
  },
  {
    name: 'aggregationPageIndex',
    path: 'aggregationPageIndex',
    component: () => import(/* webpackChunkName: 'defaultAggregationPageIndex' */ '../views/patient/aggregationPage/index.vue'),
  },
  {
    name: 'aggregationPageDetail',
    path: 'aggregationPageDetail',
    component: () => import(/* webpackChunkName: 'defaultAggregationPageDetail' */ '../views/patient/aggregationPage/detail.vue'),
    meta: {
      tabGroup: 'aggregationPageIndex',
    },
  },
  {
    name: 'defaultMsgTemplateManage',
    path: 'msgTemplateManage',
    component: () => import(
      /* webpackChunkName: 'defaultTemplateManage' */
      '@/views/templateManage/index.vue'), // 模版管理
    meta: {
      keepAlive: true,
    },
  },
];
